import { render, staticRenderFns } from "./NavigationFilledIcon.vue?vue&type=template&id=68d7ec0c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports